import React from 'react';
import { useIntl } from 'react-intl';
import { Spinner } from '@dropbox/dig-components/progress_indicators';
import * as css from 'js/file_viewer/loading_indicator/loading_indicator.module.css';
export const LoadingIndicator = ({}) => {
    const intl = useIntl();
    return (React.createElement("div", { className: css.loadingContent },
        React.createElement(Spinner, { "aria-label": intl.formatMessage({ id: "zqXonC", defaultMessage: "Your preview is loading" }) })));
};
LoadingIndicator.displayName = "LoadingIndicator"
//# sourceMappingURL=loading_indicator.preenvesnextjs.map
